import React, { Component } from 'react';

import { SecondsToHHMMSS } from '../../../common/constant';

export class ReverseTimer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: props.intialTimerValue || 0,
      stopTimerOnBtnClick: props.stopTimerOnMount || false,
      disabled: false,
    };
  }
  timerFunc = () => {
    const { stopTimerOnBtnClick } = this.state;
    const { onStopTimer = () => {}, onStartTimer = () => {} } = this.props;
    if (stopTimerOnBtnClick) {
      clearInterval(this.timer);
      onStopTimer();
    } else {
      clearInterval(this.timer);
      onStartTimer();
      this.timer = setInterval(this.tick, 1000);
    }
  };

  tick = () => {
    const { apiCall } = this.props;
    this.setState({ count: this.state.count - 1 });
    apiCall &&
      apiCall({
        count: this.state.count - 1,
        timer: this.state.count - 1,
      });
  };
  componentDidMount() {
    if (!this.props.stopTimerOnMount) this.timer = setInterval(this.tick, 1000);
  }
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  componentDidUpdate(prevProps) {
    const { stopTimer } = this.props;
    if (stopTimer && prevProps.stopTimer !== stopTimer) {
      this.setState({ stopTimerOnBtnClick: true, disabled: true }, () => {
        this.timerFunc();
      });
    }
  }

  render() {
    const { count, stopTimerOnBtnClick, disabled } = this.state;
    return (
      <div>
        <div className='timer_outer'>
          <i className='fa fa-clock-o' />
          <span className='timer_box'>{SecondsToHHMMSS(count)}</span>
        </div>

        <button
          type='button'
          className={`pause_btn ${
            stopTimerOnBtnClick ? 'icon-control-play' : 'icon-control-pause'
          }`}
          onClick={() =>
            this.setState({ stopTimerOnBtnClick: !stopTimerOnBtnClick }, () => {
              this.timerFunc();
            })
          }
          disabled={disabled}
        />
      </div>
    );
  }
}

export default ReverseTimer;



// WEBPACK FOOTER //
// ./src/views/ESG/Timer/ReverseTimer.jsx